module.exports = __webpack_public_path__ + "img/QUITTING BEFORE POSTING-1-en.5ceedd2.png";